import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IInvite } from '@/contracts/system-modules/groups/IInvite'
import { CreateInviteParams } from '@/system-modules/groups/v1/api/v1/groups/CreateInvite/Dto/CreateInviteParams'

export const OFFLINE_INVITE_UUID = '00000000-0000-4000-8000-000000000003'

export class CreateInviteRoute extends GroupsRoute<CreateInviteParams, IInvite> {
  constructor(private readonly groupUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid + '/invites'
  }

  /** Без сервера инвайт выдаётся с постоянным UUID */
  offline(params: CreateInviteParams): Promise<ApiResponse<IInvite>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: { uuid: OFFLINE_INVITE_UUID, groupUuid: this.groupUuid, expiresAt: params.expiresAt, removedAt: null },
    }))
  }
}
